"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxAsync = void 0;
const recipes_1 = require("../recipes");
const min_max_ingredients_async_1 = require("./min-max-ingredients-async");
exports.maxAsync = (0, recipes_1.maxRecipe)(min_max_ingredients_async_1.minMaxIngredientsAsync);
